import React, {useEffect, useRef, useState} from 'react'
import {useDispatch} from 'react-redux'

import {apiRefreshSession} from 'api-services/AuthService'
import {Loading} from 'components/shared'
import {clearAdminClub, setClub} from 'store/auth/adminClubSlice'
import {onSignInSuccess, onSignOutSuccess} from 'store/auth/sessionSlice'
import {setUser, userLoggedOut} from 'store/auth/userSlice'
import {
    getAccessTokenFromAuthPayload,
    getAuthPayload,
    getClubFromAuthPayload,
    getUserFromAuthPayload,
} from 'utils/authSession'

const AuthBootstrap = ({children}) => {
    const dispatch = useDispatch()
    const didRun = useRef(false)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        if (didRun.current) {
            return
        }

        didRun.current = true

        const bootstrapSession = async () => {
            try {
                const response = await apiRefreshSession()
                const payload = getAuthPayload(response)
                const accessToken = getAccessTokenFromAuthPayload(payload)
                const user = getUserFromAuthPayload(payload)
                const club = getClubFromAuthPayload(payload)

                if (!accessToken) {
                    throw new Error('Missing access token in refresh response')
                }

                dispatch(onSignInSuccess({accessToken}))

                if (user) {
                    dispatch(setUser(user))
                }

                if (club) {
                    dispatch(setClub(club))
                }
            } catch {
                dispatch(onSignOutSuccess())
                dispatch(userLoggedOut())
                dispatch(clearAdminClub())
            } finally {
                setLoading(false)
            }
        }

        bootstrapSession()
    }, [dispatch])

    if (loading) {
        return (
            <div className="flex flex-auto flex-col h-[100vh]">
                <Loading loading={true} />
            </div>
        )
    }

    return <>{children}</>
}

export default AuthBootstrap
